export function msToDate(ms) {

    if (typeof ms === 'string') {
        ms = parseInt(ms, 10);
    }
    if (isNaN(ms)) {
        return '-';
    }

    const date = new Date(ms);
    const day = String(date.getUTCDate()).padStart(2, `0`);
    const month = String(date.getUTCMonth() + 1).padStart(2, `0`);
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
}


export function getYearsBetweenDates(date1, date2) {
    const year1 = msToDate(date1);
    const year2 = msToDate(date2);
    // const combinedData = year1.split("/")[2] + "-" + year2.split("/")[2];
    const combinedData = year2.split("/")[2] + "-" + year1.split("/")[2];
    return combinedData;
}


export function formatDateForInput(timestamp) {
    if (!timestamp) return '';
  const date = new Date(parseInt(timestamp));
  if (isNaN(date.getTime())) return '';
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${month}-${day}-${year}`;
};


// Helper function to check if date string is complete (has all parts)
// Note: This only checks if all parts are present, not if the date is valid
export const isDateComplete = (dateString) => {
  if (!dateString || dateString.trim() === '') return false;
  
  // Split by common separators
  const parts = dateString.split(/[-\/]/);
  if (parts.length !== 3) return false;
  
  // Handle both YYYY/MM/DD and MM/DD/YYYY formats
  // Try to determine format by checking if first part is 4 digits (year)
  const firstPart = parts[0].trim();
  const secondPart = parts[1].trim();
  const thirdPart = parts[2].trim();
  
  let year, month, day;
  
  // If first part is 4 digits, assume YYYY/MM/DD format
  if (firstPart.length === 4 && /^\d{4}$/.test(firstPart)) {
    [year, month, day] = [firstPart, secondPart, thirdPart];
  } else {
    // Otherwise assume MM/DD/YYYY format
    [month, day, year] = [firstPart, secondPart, thirdPart];
  }
  
  // Check if all parts have values
  if (!year || !month || !day) return false;
  
  // Check if values are valid numbers
  const yearNum = parseInt(year, 10);
  const monthNum = parseInt(month, 10);
  const dayNum = parseInt(day, 10);
  
  if (isNaN(yearNum) || isNaN(monthNum) || isNaN(dayNum)) return false;
  
  // Basic range checks for month and day (to ensure they're reasonable)
  // Note: We don't check year range here as that's a validity check, not completeness
  if (monthNum < 1 || monthNum > 12) return false;
  if (dayNum < 1 || dayNum > 31) return false;
  
  // If year is present and is a number, consider the date complete
  // Year range validation should be done separately if needed
  return true;
};

export function msToDateTree(ms) {

    if (typeof ms === 'string') {
        ms = parseInt(ms, 10);
    }
    if (isNaN(ms)) {
        return '-';
    }

    const date = new Date(ms);
    const day = String(date.getUTCDate()).padStart(2, `0`);
    const month = String(date.getUTCMonth() + 1).padStart(2, `0`);
    const year = date.getUTCFullYear();
    return `${month}/${day}/${year}`;
}